import { get, merge } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { REDUCER } from 'constants/entity-names';
import { getStore } from 'store';
import { getVisibleItems } from 'resolvers/getVisibleEntities';

// get store
const store = getStore();

/*************************************************************/

/**
 * @type {class}
 * @desc MemberDetailsPayBalanceWidget defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { MemberDetailsPayBalanceWidgetService } from 'services/memberDetailsPayBalanceWidget';
 *
 * // create service instance and send/cancel request
 * const memberDetailsPayBalanceWidgetService = new MemberDetailsPayBalanceWidgetService();
 * const result = await memberDetailsPayBalanceWidgetService.fetchData( '<user-id>' ); // fetch data
 * memberDetailsPayBalanceWidgetService.cancel(); // cancel an active request
 */
export class MemberDetailsPayBalanceWidgetService extends HttpService {

    // make request and fetch component data
    async fetchComponentData( { url, data } ) {

        // get ongoing call info from the redux store
        const callId = get( store.getState()[ REDUCER.CALL_STATE ], 'callId', null );

        const callerType = get( store.getState()[ REDUCER.CALL_STATE ], 'callerType', null );

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: merge( data, {
                    context: {
                        callId,
                        callerType
                    }
                } ),
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    title: get( response, 'body.component.structure.title', {} ),
                    balanceAndSavings: get( response, 'body.component.data.state', {} ),
                    cards: get( response, 'body.component.structure.cards', [] ),
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    async fetchPayBalanceStepsData( { url, data  } ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            // extract data
            const visibility = get( response, 'body.component.visibility', {} );
            const steps = get( response, 'body.component.structure.steps', [] );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    steps: getVisibleItems( steps, visibility ),
                    currentStep: get( response, 'body.component.data.state.currentStep', 1 )
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

}
